import { CellProps } from 'react-table';

import { CellText, RotatedHeader } from 'coreOld/elements';
import { IAccessRank } from 'system/types';

export const columns = [
  {
    Header: <RotatedHeader text="Access" />,
    accessor: 'accessName',
    Cell: ({ row }: CellProps<IAccessRank, any>) => {
      const accessUrls = !row.original.accessName ? [] : [row.original.accessUrl];

      if (row.original.accessUrls) {
        accessUrls.push(...row.original.accessUrls.split(', '));
      }

      return (
        <CellText
          mainText={row.original.accessName || row.original.accessUrl}
          subTexts={accessUrls}
        />
      );
    },
  },
];
